// extracted by mini-css-extract-plugin
module.exports = {"accordian-toggle":"FAQAccordionList_accordian-toggle__7di_w","card":"FAQAccordionList_card__OfqXl"};